import script from "./WorkflowEditorCanvas.vue?vue&type=script&lang=js"
export * from "./WorkflowEditorCanvas.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__